var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 5.83334V5.66667C16.6666 4.26654 16.6666 3.56647 16.3942 3.0317C16.1545 2.56129 15.772 2.17884 15.3016 1.93916C14.7668 1.66667 14.0668 1.66667 12.6666 1.66667H7.33331C5.93318 1.66667 5.23312 1.66667 4.69834 1.93916C4.22793 2.17884 3.84548 2.56129 3.6058 3.0317C3.33331 3.56647 3.33331 4.26654 3.33331 5.66667V14.3333C3.33331 15.7335 3.33331 16.4335 3.6058 16.9683C3.84548 17.4387 4.22793 17.8212 4.69834 18.0609C5.23312 18.3333 5.93318 18.3333 7.33331 18.3333H10.4166M10.4166 9.16667H6.66665M9.58331 12.5H6.66665M13.3333 5.83334H6.66665M15 15V10.4167C15 9.72632 15.5596 9.16667 16.25 9.16667C16.9403 9.16667 17.5 9.72632 17.5 10.4167V15C17.5 16.3807 16.3807 17.5 15 17.5C13.6193 17.5 12.5 16.3807 12.5 15V11.6667",
    stroke: "#FAFEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/Reporting.192e6a25403b1d95ac2bedd820018519.svg";
export { ForwardRef as ReactComponent };